import React, { useReducer, useEffect } from "react";
import { Table, Row, Col, Button, Alert } from "react-bootstrap";
import ModuleDisplayEmail from "../modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../modules/fieldsDisplay/ModuleDisplayPhone";
import {
  listingInitialState,
  listingReducer,
} from "../../../reducers/module/listingReducer";
import axios from "../../../config/axios";
import moduleConfig from "../../modules/payments/moduleConfig";
import { getCurrencyCode, getFullName } from "../../../helpers/CommonHelper";
import ModuleDisplayDateTime from "../modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayBoolean from "../modules/fieldsDisplay/ModuleDisplayBoolean";
import { Link, useNavigate } from "react-router-dom";
import { FullPageOverlay } from "../loading/FullPageOverlay";
import ModuleDisplayArray from "../modules/fieldsDisplay/ModuleDisplayArray";
import ModuleDisplayDate from "../modules/fieldsDisplay/ModuleDisplayDate";
import { BiCard, BiCheckCircle, BiCreditCard, BiError } from "react-icons/bi";
import { BsClockFill, BsClockHistory } from "react-icons/bs";
function PaymentContent({ setParent, parent }) {
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );

  const navigate = useNavigate();

  const handleNavigate = (url) => {
    navigate(url);
  };
  const loadItems = async () => {
    listingDispatch({ type: "FETCH_REQUEST" });
    setParent(true);

    try {
      const res2 = await axios.get(`payments?limit=5`);

      // Combine both API data if needed
      const combinedData = {
        items: res2.data?.items,
      };

      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: combinedData,
      });
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    } finally {
      setParent(false);
    }
  };

  useEffect(() => {
    loadItems();
  }, []);
  return (
    <>
      <Row className="my-2">
        <Col>
          {listingState.hasFetchingError && (
            <Alert variant="warning mb-0 mt-1">
              OOPS!!! Something went wrong, please try again later.
            </Alert>
          )}
          {listingState.data && listingState.data.items && (
            <>
              <Row className="my-2">
                <Col xl={4} lg={3} md={3} sm={3} xs={12}>
                  <a
                    onClick={() => handleNavigate(`/payments`)}
                    title="Please click to view all orders"
                  >
                    <div className="info-box bg-linear-4 text-white">
                      <span className="info-box-icon">
                        <BiCreditCard size={40} />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Total Payments</span>
                        <span
                          className="info-box-number fs-3"
                          style={{ lineHeight: "30px" }}
                        >
                          {listingState.data.items?.length}
                        </span>
                      </div>
                    </div>
                  </a>
                </Col>
              </Row>
            </>
          )}
          {listingState.data.items && listingState.data.items.length <= 0 && (
            <Alert className="alert-custom-1 mb-0 mt-1">
              No records found.
            </Alert>
          )}
          {listingState?.data?.items &&
            listingState?.data?.items?.length > 0 && (
              <Row>
                <Col>
                  <>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h5 className="text-bold fs-9 ">Recent Payments</h5>
                        {/* <p className="mb-0 text-white font-italic fs-12 text-left heartbeat hide  mb-0">Admin Action Required</p> */}
                      </div>
                      <div>
                        <Link
                          to={"/orders"}
                          className="btn btn-xs btn-custom-2 fontItalic"
                        >
                          {" "}
                          View More
                        </Link>
                      </div>
                    </div>
                    <div className="registrationTable overflow-auto">
                      <table class="custom-table mt-1">
                        <thead>
                          <tr>
                            <th>Full Name</th>
                            <th className="text-center">Purpose</th>
                            <th class="text-center">Amount (AED)</th>
                            <th class="text-center">Payment Status</th>
                            <th className="text-center">Payment Date</th>
                          </tr>
                        </thead>

                        <tbody>
                          {listingState?.data?.items.map((item, index) => {
                            return (
                              <tr
                                title="View details"
                                onClick={() =>
                                  handleNavigate(`/payments/${item._id}`)
                                }
                              >
                                <td>
                                  {item?.order?.customer?.fullName ||
                                    item?.subscription?.customer?.fullName ||
                                    "-"}
                                </td>

                                <td className="text-center">{item?.purpose}</td>
                                <td className="text-center text-custom-1 text-bold">
                                  {item?.totalAmount} {getCurrencyCode()}
                                </td>
                                <td className="text-center">
                                  <span
                                    class={`status ${
                                      item?.status === "1"
                                        ? "active"
                                        : "inactive"
                                    }`}
                                  >
                                    {item?.status === "1" ? "Paid" : "Pending"}
                                  </span>
                                </td>
                                <td className="text-center ">
                                  <ModuleDisplayDate value={item?.createdAt} />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                </Col>
              </Row>
            )}
        </Col>
      </Row>
    </>
  );
}

export default PaymentContent;
